import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import moment from 'moment';
import DiscoveryApprovalModal from './DiscoveryApprovalModal';
import {
  emptyReviewDetails,
  getCommonOneApprovalAsync,
  getReviewDetailsAsync,
} from '../ApprovalStore/approvalSlice';
import { useDispatch } from 'react-redux';

export const DISCOVERY_REVIEW_TABLE_COLUMNS = [
  { Header: 'ID', accessor: '_id' },
  { Header: 'Entity Type', accessor: 'entityType' },
  { Header: 'Approval Type', accessor: 'approvalType' },
  { Header: 'New value', accessor: 'newValue' },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Created at',
    accessor: 'createdAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { createdAt } = payload;
      return (
        <>
          <Box>{moment(createdAt).format('MMMM Do, YYYY')}</Box>
        </>
      );
    },
  },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const dispatch = useDispatch();
      const [openModal, setOpenModal] = useState(false);
      return (
        <>
          <DiscoveryApprovalModal
            open={openModal}
            onClose={() => {
              setOpenModal(false);
              dispatch(emptyReviewDetails());
            }}
          />
          <Box
            onClick={() => {
              setOpenModal(true);
              dispatch(getCommonOneApprovalAsync({ _id: payload._id }));
              dispatch(getReviewDetailsAsync({ entityId: payload.entityId }));
            }}
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}>
            View Details
          </Box>
        </>
      );
    },
  },
];
